import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Hero from '../../components/home/Hero';
import LogoBar from '../../components/home/LogoBar';
import Testimonials from '../../components/home/Testimonials';
import BlogHighlights from '../../components/home/BlogHighlights';
import ToolkitCards from '../../components/home/ToolkitCards';
import CommunityCalls from '../../components/home/CommunityCalls';
import EventsStream from '../../components/events/EventsStream';
import PageMeta from '../../components/common/PageMeta';

const Home = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <PageMeta description={t('home.meta_description')} />
      <Hero />
      <LogoBar />
      <Testimonials />
      <BlogHighlights />
      <EventsStream />
      <ToolkitCards />
      <CommunityCalls />
    </Box>
  );
};

export default Home;
